<br><br><br><br><br><br>
<div class="generate">{{ "Interview Training" | translate }}</div>

<!-- Loading Spinner -->
<div *ngIf="isLoading" class="text-center my-5">
  <p-progressSpinner></p-progressSpinner>
  <p class="mt-3">{{ "Loading..." | translate }}</p>
</div>

<!-- Content (shows after loading) -->
<div *ngIf="!isLoading">
  <!-- Desktop steps - original -->
  <div class="my-4 d-none d-md-block">
    <p-steps [model]="steps" [(activeIndex)]="vrActiveIndex" />
  </div>
  
  <!-- Mobile steps -->
  <div class="mobile-steps d-block d-md-none">
    <div class="mobile-step-container">
      <div class="step-circle" 
           [class.active]="vrActiveIndex === 0" 
           [class.completed]="vrActiveIndex > 0"
           (click)="onStepClick(0)"
           style="cursor: pointer;">
        1
      </div>
      
      <div class="step-segments-container">
        <div class="step-segment" [class.active]="vrActiveIndex >= 0"></div>
        <div class="step-segment" [class.active]="vrActiveIndex >= 1"></div>
        <div class="step-segment" [class.active]="vrActiveIndex >= 2"></div>
      </div>
      
      <div class="step-circle" 
           [class.active]="vrActiveIndex === 2" 
           [class.completed]="vrActiveIndex > 2"
           (click)="onStepClick(2)"
           style="cursor: pointer;">
        3
      </div>
    </div>
  </div>

  <!-- Step Components -->
  <app-upload-resume 
    *ngIf="vrActiveIndex === 0" 
    (next)="onResumeNext($event)" 
    (previous)="previous()" 
  />
  
  <app-opportunity-details 
    *ngIf="vrActiveIndex === 1"
    [initialData]="opportunityData"
    (next)="onOpportunityNext($event)" 
    (previous)="previous()" 
  />
  
  <app-vr-trails 
    *ngIf="vrActiveIndex === 2" 
    (next)="next()" 
    (previous)="previous()" 
  />
</div>